import { waitingForMessage } from '../../../approach-react/common/messaging.js';

const waitingForReactMessage = (projectId, timeoutFunc, callback) => {
  waitingForMessage((ev) => {
    if (ev.data.projectId !== projectId) {
      return;
    }
    if (ev.data.to !== "Angular") {
      return;
    }

    timeoutFunc(() => {
      callback && callback(ev.data.kind, ev.data.data);
    });
  });
};

const waitingForEnableNextButton = (projectId, timeoutFunc, callback) => {
  waitingForReactMessage(projectId, timeoutFunc, (kind) => {
    if (kind === "enableNextButton") {
      callback && callback();
    }
  });
};

const waitingForDisableNextButton = (projectId, timeoutFunc, callback) => {
  waitingForReactMessage(projectId, timeoutFunc, (kind) => {
    if (kind === "disableNextButton") {
      callback && callback();
    }
  });
};

export { waitingForReactMessage, waitingForEnableNextButton, waitingForDisableNextButton };
